import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.15 }}
            transition={{ duration: 0.7, delay, ease: easeOut }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={`block overflow-hidden ${className}`}>
            <motion.span
                className="block"
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.9, delay, ease: easeOut }}
            >
                {children}
            </motion.span>
        </span>
    );
}
